import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import JisButton from "../../components/controls/jisButton";
import DynamicIcon from "../../components/dynamicicon";
import JisYesNo from "../../components/controls/jisYesNo";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import CaseHeader from "../../components/core/CaseHeader";
import RelatedCasesModal from "./related_cases_modal";

function Bulk_assignment() {
  const location = useLocation();
  const navigate = useNavigate();
  const { token, frequentData, setIsExpired, setAlert } =
    useContext(ShareContext);

  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [isCmc, setIsCmc] = useState(null);
  const [option, setOption] = useState({});
  const [roles, setRoles] = useState([]);
  const [judges, setJudges] = useState([]);
  const [assignTo, setAssignTo] = useState(null);
  const [selectedCases, setSelectedCases] = useState({});
  const [selected, setSelected] = useState(new Set());
  const [sliceIndex, setSliceIndex] = useState(3);
  const [relatedCasesData, setRelatedCasesData] = useState([]);
  const [showRelatedCases, setShowRelatedCases] = useState(false);
  const [relatedCasesLoading, setRelatedCasesLoading] = useState(false);
  const [judgeSearch, setJudgeSearch] = useState("");
  const [filteredJudges, setFilteredJudges] = useState([]);
  console.log(selectedCases);
  useEffect(() => {
    if (location.state) {
      const {
        selectedCases: cases,
        selected: sel,
        option: opt,
      } = location.state;
      setSelectedCases(cases || {});
      setSelected(new Set(sel) || new Set());
      setOption(opt || {});
    }
    onLoadRoles();
  }, [location.state]);

  useEffect(() => {
    if (
      !(option.divisionId == null || option.divisionId == "") &&
      !(option.roleId == null || option.roleId == "")
    ) {
      setAssignTo(null);
      setJudges([]);
      onLoadUserByRoleandDivision();
    }
  }, [option.divisionId, option.roleId]);

  const onLoadRoles = async () => {
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getrolesBySearch/judge`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setRoles(data.roles);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const getRelatedCases = async (caseId) => {
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/hearing/get-related-cases-bay-case-id/${caseId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      console.log(`Related cases for caseId ${caseId}:`, data);
      return data;
    } catch (error) {
      console.error(
        `Error fetching related cases for caseId ${caseId}:`,
        error,
      );
      return null;
    }
  };

  const getAllRelatedCases = async (cases) => {
    setRelatedCasesLoading(true);
    const caseIds = Object.values(cases).map((caseObj) => caseObj.caseId);
    console.log("Starting sequential API calls for case IDs:", caseIds);
    const results = [];

    for (const caseId of caseIds) {
      console.log(`Fetching related cases for caseId: ${caseId}`);
      const result = await getRelatedCases(caseId);
      results.push({ caseId, data: result });
    }

    console.log("All results:", results);

    // Check if any case has related cases
    const hasAnyRelatedCases = results.some(
      (caseGroup) => caseGroup.data?.results?.length > 0,
    );

    if (hasAnyRelatedCases) {
      setRelatedCasesData(results);
      setShowRelatedCases(true);
    } else {
      console.log("No related cases found for any of the selected cases");
    }

    setRelatedCasesLoading(false);
    return results;
  };

  useEffect(() => {
    if (selectedCases && Object.keys(selectedCases).length > 0) {
      getAllRelatedCases(selectedCases);
    }
  }, [selectedCases]);

  const handleRemoveCasesWithRelated = (caseIdsToRemove) => {
    // Remove cases from selectedCases object
    const updatedCases = { ...selectedCases };
    caseIdsToRemove.forEach((caseId) => {
      delete updatedCases[caseId];
    });

    // Remove from selected Set
    const updatedSelected = new Set(selected);
    caseIdsToRemove.forEach((caseId) => {
      updatedSelected.delete(caseId);
    });

    setSelectedCases(updatedCases);
    setSelected(updatedSelected);
    setShowRelatedCases(false);

    // Check if all cases have been removed
    if (Object.keys(updatedCases).length === 0) {
      // All cases removed, navigate back
      setAlert({
        open: true,
        title: "All Cases Removed",
        subtitle: `All ${caseIdsToRemove.length} case(s) with related cases have been removed from assignment`,
      });
      navigate("/case-assigment");
    } else {
      // Some cases remain
      setAlert({
        open: true,
        title: "Cases Removed",
        subtitle: `${caseIdsToRemove.length} case(s) with related cases removed from assignment`,
      });
    }
  };
  const onLoadUserByRoleandDivision = async () => {
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getUsersByRole/${option.roleId}/${option.divisionId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setJudges(data.pros);
        setFilteredJudges(data.pros);
        setJudgeSearch("");
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  // Filter judges based on search
  useEffect(() => {
    if (judgeSearch.trim() === "") {
      setFilteredJudges(judges);
    } else {
      const searchLower = judgeSearch.toLowerCase();
      const filtered = judges.filter((judge) => {
        const fullName = Constants.judgeName(judge).toLowerCase();
        return fullName.includes(searchLower);
      });
      setFilteredJudges(filtered);
    }
  }, [judgeSearch, judges]);

  const onSave = async (e) => {
    e.preventDefault();
    if (option.caseFilingId == 1 && isCmc == null) {
      setErr("Please select the Case Event Option");
      return;
    }

    if (assignTo == null) {
      setErr("Please select one of the listed Judges");
      return;
    }

    var caseids = Array.from(selected);
    setErr("");
    var judgeAs = isCmc == true ? "CMC" : "Trial";
    var approve = {
      ...option,
      isCms: isCmc,
      caseids: caseids,
      assignType: "judge",
      judgeAs: judgeAs,
      assignTo: assignTo,
    };

    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/Assign-Cases`, {
        method: "POST",
        body: JSON.stringify(approve),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        const isADR = option?.caseFilingId === 2;

        if (isCmc == false) {
          setAlert({
            open: true,
            title: "Case Assignment",
            subtitle: "Trial Cases assigned successfully",
          });
        } else {
          setAlert({
            open: true,
            title: "Case Assignment",
            subtitle: `${isADR ? "ADR" : "CMC"} Cases assigned successfully`,
          });
        }
        navigate(-1);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
    }
  };

  const onOptionChange = (e) => {
    setOption({ ...option, [e.target.name]: e.target.value });
  };

  const onCancel = () => {
    navigate(-1);
  };

  useEffect(() => {
    const divisionFromState = location.state?.divisionId;

    if (divisionFromState && !option.divisionId) {
      setOption((prev) => ({ ...prev, divisionId: divisionFromState }));
    }
  }, [location.state, option.divisionId]);

  return (
    <div>
      <CaseHeader />
      <form onSubmit={onSave}>
        <div className="bulk_assignment_form_wrapper">
          <div className="form_right_content">
            {option.caseFilingId == 1 && (
              <JisYesNo
                label="Assign Case"
                value={isCmc}
                yes="CMC"
                no="Trial"
                onChange={(e) => setIsCmc(e)}
              />
            )}
            <div>
              <div className="select-group">
                <label>Division</label>
                <select
                  name="divisionId"
                  value={option.divisionId}
                  onChange={onOptionChange}
                  required
                >
                  <option value="">Select </option>
                  {frequentData.divisions?.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="select-group">
                <label>Role:</label>
                <select
                  name="roleId"
                  value={option.roleId}
                  onChange={onOptionChange}
                  required
                >
                  <option value="">Select Role </option>
                  {roles?.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="select-group">
                <label>
                  Judges:{" "}
                  <strong style={{ fontSize: 12 }}>
                    (Please select one of the Judges){" "}
                  </strong>
                </label>
                {/* {judges?.length > 5 && ( */}
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    placeholder="Search judges..."
                    value={judgeSearch}
                    onChange={(e) => setJudgeSearch(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #C8CACE",
                      borderRadius: "4px",
                      fontSize: "14px",
                    }}
                  />
                </div>
                {/* )} */}
                <div className="" style={{ maxHeight: 300, overflowY: "auto" }}>
                  {filteredJudges?.length === 0 ? (
                    <div
                      style={{
                        padding: "10px",
                        textAlign: "center",
                        color: "#666",
                      }}
                    >
                      {judges?.length === 0
                        ? "No judges available"
                        : "No judges found"}
                    </div>
                  ) : (
                    filteredJudges?.map((opt) => (
                      <div
                        key={opt.id}
                        onClick={() => setAssignTo(opt.id)}
                        className={`selected ${
                          opt.id === assignTo ? "active" : ""
                        }`}
                      >
                        {Constants.judgeName(opt)}
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
            <div className="input-group">
              <label>Comment</label>
              <div>
                {" "}
                <textarea
                  placeholder=" Comment"
                  name="comment"
                  required={true}
                  value={option.comment}
                  onChange={onOptionChange}
                  className="bulk_comment_textarea"
                />
              </div>
            </div>
            {err != "" && <div className="error">{err}</div>}
            <button
              type="button"
              className="bulk_cancel_btn"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button className="bulk_assign_btn" type="submit">
              Assign{" "}
            </button>
          </div>
          <div className="">
            <div className="selected_cases_wrapper">
              {Object.values(selectedCases)
                ?.slice(0, sliceIndex)
                .map((opt, index) => (
                  <div className="selected_case_card" key={index}>
                    <p>{opt.caseNumber}</p>
                    <p>{opt.caseTitle}</p>
                  </div>
                ))}
            </div>

            {Object.values(selectedCases).length > 3 && sliceIndex === 3 && (
              <button
                type="button"
                onClick={() =>
                  setSliceIndex(Object.values(selectedCases).length)
                }
              >
                +{Object.values(selectedCases).length - 3} More cases
              </button>
            )}
          </div>
        </div>
      </form>
      <BackLoader open={loading || relatedCasesLoading} />

      {showRelatedCases && relatedCasesData.length > 0 && (
        <div className="related-case-table-modal">
          <RelatedCasesModal
            relatedCasesData={relatedCasesData}
            selectedCases={selectedCases}
            onClose={() => setShowRelatedCases(false)}
            onRemoveCases={handleRemoveCasesWithRelated}
            frequentData={frequentData}
          />
        </div>
      )}
    </div>
  );
}

export default Bulk_assignment;
